import React from 'react';

export default class  Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <ul className="greenbullet-list people-list-pad">
                                                <li>Working conditions</li>
                                                <li>Feelings of job security.</li>
                                            </ul>
                                            <div className="paraspace"><p>Typical motivation factors necessary
                                                to spur effort and productivity include:</p></div>
                                            <ul className="greenbullet-list people-list-pad">
                                                <li>Status</li>
                                                <li>Opportunity for advancement</li>
                                                <li>Gaining recognition</li>
                                                <li>Responsibility</li>
                                                <li>Challenging/stimulating work</li>
                                                <li>Sense of personal achievement &amp; personal growth in a
                                                    job.
                                                </li>
                                            </ul>
                                            <p>Our energy levels, whether at work or in our personal lives,
                                                depend on whether the things which motivate us are satisfied.
                                                For example, we’re much more energised if the tasks and goals
                                                we’re given at work have meaning or significance for us
                                                personally, and this is also true of our relationships and
                                                environment.</p>
                                            <div className="browncontentbg uiheading keyquestionpad">
                                                <p>In the following sections, we’re going to discuss what you
                                                    can do physically to increase your own energy and, then, how
                                                    to use psychological means of increasing the energy of those
                                                    around you.</p>
                                            </div>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span
                                                    className="heading">HAVING THE ENERGY TO ENERGISE OTHERS</span>
                                            </div>
                                            <p>There will always be days when you’d rather hide under your desk,
                                                let alone have to pull others out from under theirs! Before you
                                                can energise them, however, you need to energise yourself.
                                                Simply making the decision to take control, being positive and
                                                preparing yourself physically is fundamental to energising
                                                yourself psychologically.<a className="superscripttext"
                                                                            href="further_info.php?course=300"><sup>3</sup></a>
                                            </p>
                                            <div className="border_subtitle">Straighten up<a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>3</sup></a></div>
                                            <p>
                                                Your mother was right to tell you to stand up straight! When you
                                                slouch, your muscles have to work harder to hold you up, which
                                                saps energy. For example, just 15 minutes of reading while
                                                slouched or hunched can exhaust the neck and shoulder
                                                muscles.</p>
                                            <p>While all processing of our emotions and consciousness occurs in
                                                the brain, our body provides key feedback into how we feel and
                                                think. For example,<a className="superscripttext"
                                                                      href="further_info.php?course=300"><sup>4</sup></a> smiling
                                                uses muscles which then send feedback to the brain making us
                                                feel happier. In an extreme example of this, it’s been proven
                                                that people who have had botox injections to force their face
                                                into a more smile-like appearance have elevated moods compared
                                                to before their procedure. So think about your muscles as well
                                                as your mind when trying to raise your energy levels.</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">To maintain good posture:</div>
                                                <ul className="greenbullet-list keyquestionpad">
                                                    <li>When standing, keep your shoulders and hips lined up,
                                                        and your head straight.
                                                    </li>
                                                    <li>When sitting, use a chair with good lower back support
                                                        and keep your knees a bit higher than your hips.
                                                    </li>
                                                    <li>Breathe deeply, inhaling as much oxygen as you can,
                                                        letting your whole torso inflate before exhaling.
                                                    </li>
                                                    <li>Don’t stay in the same position for too long – try to
                                                        take a one-minute break every 20 minutes, even if you
                                                        only walk around your desk!
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page2')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page4')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}